<template>
    <transition-group name="fade" tag="div" class="c-toast-container">
        <c-toast
            v-for="toast in toasts"
            :toast="toast"
            :key="toast.id">
        </c-toast>
    </transition-group>
</template>

<script>
import CToast from '@components/toast/Element';
import { mapState } from 'vuex';

export default {
    components: { CToast },
    computed: {
        ...mapState({
            toasts: state => state.toasts.list.reverse()
        })
    }
}
</script>
